export default {"src":"/_next/static/media/promote.90a0fe97.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};